export default __webpack_public_path__ + "static/media/pm25.c3691db7.svg";